import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "@/components/feature/LanguageSwitcher";
import { MAIN_SITE_URL } from "@/data/categories";

export default function Header() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-grid-line text-lg"></i>
          </span>
          <span className="text-base font-bold text-foreground-900 whitespace-nowrap">
            AllChinaBuy<span className="text-primary-600"> Spreadsheet</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-6 md:flex">
          <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            {t("nav.home")}
          </Link>
          <Link to="/products" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            {t("nav.products")}
          </Link>
          <Link to="/spreadsheet-guide" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            {t("nav.guide")}
          </Link>
          <a
            href="#categories"
            className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t("nav.categories")}
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 cursor-pointer transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            {t("nav.visitSite")}
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 md:hidden cursor-pointer"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-2">
            <Link to="/" onClick={() => setOpen(false)} className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">
              {t("nav.home")}
            </Link>
            <Link to="/products" onClick={() => setOpen(false)} className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">
              {t("nav.products")}
            </Link>
            <Link to="/spreadsheet-guide" onClick={() => setOpen(false)} className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">
              {t("nav.guide")}
            </Link>
            <a href="#categories" onClick={() => setOpen(false)} className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">
              {t("nav.categories")}
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="mt-1 inline-flex items-center justify-center rounded-md bg-primary-500 px-3 py-2 text-sm font-semibold text-background-50 cursor-pointer"
            >
              {t("nav.visitSite")}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}